import { StoreRegion } from '../../types/StoreRegion';

import { doClientRequest } from './core/ErplyAPI';

export const getStoreRegions = params =>
  doClientRequest<StoreRegion>({ ...params, request: 'getStoreRegions' });
